enum LearningModes {
	questions = "question",
	essays = "essay",
}

export { LearningModes };
